import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-market-study-others',
  templateUrl: './market-study-others.component.html',
  styleUrls: ['./market-study-others.component.css']
})
export class MarketStudyOthersComponent implements OnInit {

  output: any = [];
  isLoader = false;
  body = true;
  space = " ";

  // Industry types
  industry_type = [
    { "name": "Wood" },
    { "name": "Automotive" },
    { "name": "Industrial" },
    { "name": "Building Materials" }
  ];

  // Search filters
  search_filter = {
    created_by_id: "",
    customer_name: "",
    customer_type: "",
    industry_type: "",  // Industry type filter
    marketing_country_id: "",
    marketing_state_id: "",
    marketing_area_id: "",
  };

  country_drop: any;
  statedrop: any;
  areadrop: any;

  constructor(private service: ServiceService) {}

  ngOnInit(): void {
    this.searchListing();
    this.dropdowncall();
  }

  // Excel Export
  excelExport() {
    var orderTable = document.getElementById('MarketStudyOthers');
    if (!orderTable) return;
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });
    XLSX.writeFile(wb, 'Market_Study_Others.xlsx');
  }

  // Always fetch data excluding Decorative Coatings
  searchListing() {
    // Update the query to include both industry_type and customer_type
    const query = `?industry_type=${this.search_filter.industry_type}&marketing_country_id=${this.search_filter.marketing_country_id}&marketing_state_id=${this.search_filter.marketing_state_id}&marketing_area_id=${this.search_filter.marketing_area_id}&customer_name=${this.search_filter.customer_name}&customer_type=${this.search_filter.customer_type || ""}`;

    this.isLoader = true;
    this.service.viewMarketStudy(query).subscribe((res) => {
      this.output = res.data.filter((item: any) => item.industry_type !== "Decorative Coatings");
      console.log("Others data=", this.output);
      console.log("res=", res);
      this.isLoader = false;
    }, err => {
      console.error("Error fetching Others data", err);
      this.isLoader = false;
    });
  }

  // Filter events
  industrySelected() {
  if (!this.search_filter.industry_type) {
    // Reset to empty string if cleared
    this.search_filter.industry_type = "";
  }

  console.log('Industry Type Filter:', this.search_filter.industry_type);
  this.searchListing();
}

  countrySelected() {
    this.statedrop = [];
    this.search_filter.marketing_state_id = "";
    if (this.search_filter.marketing_country_id == null) {
      this.search_filter.marketing_country_id = "";
    }
    this.searchListing();
    this.stateDropdown();
  }

  stateSelected() {
    this.areadrop = [];
    this.search_filter.marketing_area_id = "";
    if (this.search_filter.marketing_state_id == null) {
      this.search_filter.marketing_state_id = "";
    }
    this.searchListing();
    this.AreaDropdown();
  }

  areaSelected() {
    if (this.search_filter.marketing_area_id == null) {
      this.search_filter.marketing_area_id = "";
    }
    this.searchListing();
  }

  customerSelected() {
    this.searchListing();
  }

  // Dropdown loading
  dropdowncall() {
    this.service.viewMarketCountry().subscribe((res) => {
      this.country_drop = res.data;
    });
  }

  stateDropdown() {
    var id = this.search_filter.marketing_country_id;
    this.service.viewMarketState(id).subscribe((res) => {
      this.statedrop = res.data;
    });
  }

  AreaDropdown() {
    var id = this.search_filter.marketing_state_id;
    this.service.viewMarketArea(id).subscribe((res) => {
      this.areadrop = res.data;
    });
  }

  hasProperty(property: string): boolean {
    return this.output.some((employee: any) => !!employee[property]);
  }
}
